/* Libraries */
// import Link from 'next/link';
import cn from 'classnames';
import { Icon, Grid } from 'ht-styleguide';

/* Utils & Libs */
import { SegmentTrackingAction } from '@integrations/segment/search';

/* Hooks */
import Chat from '@integrations/gladly/Chat/Gladly.methods';

/* Constants */
import { quickLinks } from '../constants';

/* Styles */
import styles from '../searchbar.module.scss';

/* Types */
type QuickLinksProps = {
  iconClick?: BaseAnyFunction;
  searchTerm?: string;
};

const Child = ({ onClick, item }: { onClick: BaseAnyFunction; item: { name: string } }) => (
  <div onClick={onClick} className={cn('paddingX-small1', styles.clickContainer)}>
    <Grid.Column classes={styles.columnContainer}>
      <div className={styles.innerContainer}>
        <h6 className={styles.name}>{item.name}</h6>
      </div>
      <Icon name="chevron-right" className={styles.chevron} />
    </Grid.Column>
  </div>
);

const QuickLinks = ({ iconClick, searchTerm }: QuickLinksProps) => (
  <>
    <h4 data-testid="search-quick-link-title" className="marginTop-medium paddingBottom-small paddingX-small1">
      Quick Links
    </h4>
    <div onClick={iconClick}>
      <Grid.FullWidth classes={styles.categoryContainer} dataTestId="e2e-search-quick-links">
        {quickLinks.map(item => {
          const onClick = () => {
            SegmentTrackingAction.search({ searchTerm, clickedItem: 'item.name', attributes: null });
          };

          return (
            <Grid.Row key={item.id} classes={styles.customRow}>
              <a href={item.link}>
                <Child onClick={onClick} item={item} />
              </a>
            </Grid.Row>
          );
        })}
        <Grid.Row classes={styles.customRow}>
          <Grid.Column>
            <p className="p2 paddingLeft-small paddingTop-medium">
              Can’t find what you’re looking for?{' '}
              <a
                className={styles.chatLink}
                href="#"
                onClick={() => {
                  SegmentTrackingAction.search({
                    searchTerm,
                    clickedItem: 'chat',
                    attributes: null,
                  });

                  Chat.open();
                }}
              >
                Chat with Us
              </a>
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid.FullWidth>
    </div>
  </>
);

QuickLinks.defaultProps = {
  iconClick: () => {},
};

export default QuickLinks;
